import { useGLTF, useTexture } from '@react-three/drei'
import { forwardRef } from 'react';
import * as THREE from 'three';


const FlockR = forwardRef((props, ref) => {
    const floquageGltf = useGLTF('./models/truck/flockR.glb')
    const floquageTexture = useTexture('./textures/truck/flockR.jpg')
    floquageTexture.flipY = false

    return (
        <>
            <mesh 
                geometry={floquageGltf.nodes.flockR.geometry}
                onClick={(event) => event.stopPropagation()}
                onPointerEnter={(event) => event.stopPropagation()}
                ref={ref}
            >
                <meshBasicMaterial 
                    map={floquageTexture} 
                    transparent={true} 
                    opacity={1}
                    // depthWrite={false} 
                    blending={THREE.NormalBlending} 
                />
            </mesh>
        </>
    )
});

export default FlockR;